import { deepCloneObject } from '../utility';

/**
 * Helper function.
 * Conditionally clones and updates @param actions if the header action cell of index @param index
 * does not reflect the state of action cells in @param rows .
 * A header action cell should only be `Checked` if all non-header, valid action cells are `Checked`.
 *
 * @function
 * @param {Object[]} actions `actions` array in state.
 * @param {*} rows `rows` array in state.
 * @param {*} index bound `actions` index defining action of interest.
 * @returns conditionally cloned and updated array of action objects.
 */
export const updateHeaderActionCell = (actions, rows, index) => {
	let actionsUpdated = actions;
	const filteredRows = rows.filter(
		row => row.displaySearched && row.displayFiltered
	);
	const areActionCellsChecked =
		filteredRows.length > 0 &&
		filteredRows.every(row => row.ActionCells[index].Checked === true);

	if (actions[0] && actions[0].Header?.Checked !== areActionCellsChecked) {
		actionsUpdated = deepCloneObject(actions);
		actionsUpdated[0].Header.Checked = areActionCellsChecked;
	}

	return actionsUpdated;
};
